"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const stellar_sdk_1 = require("stellar-sdk");
const stellarService_1 = require("./stellarService");
const getTradeOperation = (currencies, sellAssetCode, buyAssetCode, amount, price, offerId) => {
    const sellAsset = new stellar_sdk_1.Asset(currencies[sellAssetCode].asset_code, currencies[sellAssetCode].issuer);
    const buyAsset = new stellar_sdk_1.Asset(currencies[buyAssetCode].asset_code, currencies[buyAssetCode].issuer);
    const sellOfferOptions = {
        amount: amount.toFixed(7),
        buying: buyAsset,
        price: price.toFixed(7),
        selling: sellAsset,
        offerId,
    };
    return stellar_sdk_1.Operation.manageSellOffer(sellOfferOptions);
};
exports.helloWorld = () => {
    console.log('helloWorld');
};
exports.sellAssetForTft = (keyPair, sellAssetCode, price, amount, offerId = 0) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const account = yield stellarService_1.loadAccount(keyPair);
    const { currencies, server, network } = stellarService_1.getConfig();
    const fee = yield server.fetchBaseFee();
    const transactionBuilder = new stellar_sdk_1.TransactionBuilder(account, {
        fee: '0',
        networkPassphrase: network,
    });
    const buyAssetCode = 'TFT';
    const operation = getTradeOperation(currencies, sellAssetCode, buyAssetCode, amount, price, offerId);
    transactionBuilder.addOperation(operation);
    transactionBuilder.setTimeout(3000);
    const transaction = transactionBuilder.build();
    // fee_bump
    const data = yield stellarService_1.submitFundedTransaction(transaction, keyPair);
    if (amount === 0) {
        return {
            closed: true,
        };
    }
    const transactionhash = (_a = data) === null || _a === void 0 ? void 0 : _a.transactionhash;
    if (!transactionhash) {
        throw new Error('transaction not found');
    }
    if (amount === 0) {
        return {
            closed: true,
        };
    }
    const submittedTransactionCallBuilder = server.transactions().includeFailed(true).transaction(transactionhash);
    const submittedTransaction = yield submittedTransactionCallBuilder.call();
    const resultXdr = submittedTransaction.result_xdr;
    console.log({ resultXdr });
    const result = stellar_sdk_1.xdr.TransactionResult.fromXDR(resultXdr, 'base64');
    const manageOfferSuccessResult = (_k = (_j = (_h = (_g = (_f = (_e = (_d = (_c = (_b = result) === null || _b === void 0 ? void 0 : _b.result()) === null || _c === void 0 ? void 0 : _c.innerResultPair()) === null || _d === void 0 ? void 0 : _d.result()) === null || _e === void 0 ? void 0 : _e.result()) === null || _f === void 0 ? void 0 : _f.results()) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.tr()) === null || _j === void 0 ? void 0 : _j.manageSellOfferResult()) === null || _k === void 0 ? void 0 : _k.success();
    const submitedOfferId = (_p = (_o = (_m = (_l = manageOfferSuccessResult) === null || _l === void 0 ? void 0 : _l.offer()) === null || _m === void 0 ? void 0 : _m.offer()) === null || _o === void 0 ? void 0 : _o.offerId()) === null || _p === void 0 ? void 0 : _p.low;
    console.log({ submitedOfferId });
    if (!submitedOfferId && ((_q = manageOfferSuccessResult) === null || _q === void 0 ? void 0 : _q.offersClaimed().length) >= 1) {
        return {
            closed: true,
        };
    }
    if (!submitedOfferId)
        throw new Error('no offer id found');
    return { closed: false, offerId: submitedOfferId };
});
exports.sellTft = (keyPair, buyAssetCode, price, amount, offerId = 0) => __awaiter(void 0, void 0, void 0, function* () {
    // @todo
    throw new Error('not yet implemented');
});
exports.getOpenTradeOffers = (keyPair) => __awaiter(void 0, void 0, void 0, function* () {
    const account = yield stellarService_1.loadAccount(keyPair);
    const tradeOffers = yield account.offers();
    return tradeOffers.records;
});
exports.closeTradeOffer = (keyPair, offerid) => __awaiter(void 0, void 0, void 0, function* () {
    const openTradeOffers = yield exports.getOpenTradeOffers(keyPair);
    const existingTradeOffer = openTradeOffers.find(openTradeOffer => Number(openTradeOffer.id) === offerid);
    if (!existingTradeOffer) {
        throw new Error(`offerid not found: ${offerid}`);
    }
    yield exports.sellAssetForTft(keyPair, existingTradeOffer.selling.asset_code, Number(existingTradeOffer.price), 0, offerid);
});
//# sourceMappingURL=tradeService.js.map